import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
//import firebase from 'firebase/compat/app';

import { ROUTES } from '../../sidebar/sidebar.component';
import { Router, NavigationEnd } from '@angular/router';
import { Location} from '@angular/common';

import { NotificationsService } from '../../services/notifications.service';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html',
    styleUrl: 'navbar.component.css'
})

export class NavbarComponent implements OnInit{
    private listTitles!: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton!: any;
    private sidebarVisible: boolean;
    public display: boolean;

    public isCollapsed = true;
    @ViewChild("navbar-cmp", {static: false}) button: any;

    constructor(location:Location, private renderer : Renderer2, private element : ElementRef, private router: Router, public auth: AngularFireAuth, private notification: NotificationsService, public userService: UserService) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;

        //console.log("Route : " + this.router.url)

        this.display = false;

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                console.log('ADMIN LAYOUT ROUTER EVENT : ', event);                
                
                if (event.url.startsWith("/register")) {
                    this.display = false;
                } else if (event.url.startsWith("/login")) {
                    this.display = false;
                } else if (event.url.startsWith("/reset-confirm")) {
                    this.display = false;
                } else if (event.url.startsWith("/mes-commandes")) {
                    this.display = false;
                } else if (event.url.startsWith("/mon-rendez-vous")) {
                    this.display = false;
                } else {
                    this.display = true;
                }
            }
        });
    }

    ngOnInit(){
        this.listTitles = ROUTES.filter(listTitle => listTitle);
        var navbar : HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        this.router.events.subscribe((event) => {
          this.sidebarClose();
       });
    }
    getTitle(){
        var title = this.location.prepareExternalUrl(this.location.path());
      
        //console.log("Title 0: " + title);

        if (title.charAt(0) === '#') {
            title = title.slice(1);
        }
        if (title.startsWith('/app')) {
            title = title.slice(4);
        }

        //console.log("Title : " + title);

        let suffix = (environment.production)
            ? ""
            : " - DEV";
      
        if (title === '/login') {
            return 'Authentification' + suffix;
        } else if (title === '/register') {
            return 'Inscription' + suffix;
        } else if (title === '/notify') {
            return 'Notification' + suffix;
        } else if (title.startsWith('/mes-commandes')) {
            // Public page, not a Noteefy user - no reason to show "Dashboard" here.
            // startsWith, not === : title still carries the ?token=... query string here.
            return '';
        } else if (title.startsWith('/mon-rendez-vous')) {
            return '';
        }else {
                for(var item = 0; item < this.listTitles.length; item++){
                    //console.log("listTitles : " + this.listTitles[item].path);
                    if(this.listTitles[item].path === title){
                        return this.listTitles[item].title + suffix;
                    }
            }
            return 'Dashboard' + suffix;
        }
    }
    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }
    
    sidebarOpen() {
          const toggleButton = this.toggleButton;
          const html = document.getElementsByTagName('html')[0];
          const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];
          setTimeout(function(){
              toggleButton?.classList.add('toggled');
          }, 500);

          html.classList.add('nav-open');
          // No .main-panel on the pages without sidebar (register, login...)
          if (window.innerWidth < 991 && mainPanel) {
            mainPanel.style.position = 'fixed';
          }
          this.sidebarVisible = true;
    };
    
    sidebarClose() {
          const html = document.getElementsByTagName('html')[0];
          const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];
          if (window.innerWidth < 991 && mainPanel) {
            setTimeout(function(){
              mainPanel.style.position = '';
            }, 500);
          }
          this.toggleButton?.classList.remove('toggled');
          this.sidebarVisible = false;
          html.classList.remove('nav-open');
    };
    
    collapse(){
        this.isCollapsed = !this.isCollapsed;
        const navbar = document.getElementsByTagName('nav')[0];
        console.log(navbar);
        if (!this.isCollapsed) {
          navbar.classList.remove('navbar-transparent');
          navbar.classList.add('bg-white');
        }else{
          navbar.classList.add('navbar-transparent');
          navbar.classList.remove('bg-white');
        }
    }
    
    logout() : void {
        var self = this;
        
        this.auth.signOut()
            .then(function(confirmationResult) {
                console.log('Logout OK !!!');
                self.userService.logout();
                self.notification.showNotificationSuccess("Vous êtes maintenant déconnecté");
                self.router.navigate(['login']);
            })
            .catch(function(error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                self.notification.showNotificationError(errorMessage);
                console.log("LOGOUT error: ", errorMessage);
            });
    }
    
    goToUserProfile() : void {
        this.router.navigate(['user']);
    }

    goToInvoices() : void {
        this.router.navigate(['invoices']);
    }

    // Same rule as Facturation: an admin gets the selected customer's settings
    goToNotifications() : void {
        this.router.navigate(['notifications']);
    }
        

}
